/**
 * Search Bar Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/header-search.liquid
 * 
 */

import axios from 'axios';
import debounce from 'lodash-es/debounce';
import Slick from 'vue-slick';

import { app } from '../app.js';
import { 
    fetchAutocompleteResults,
    fetchSuggestResults
} from '../vendors/searchspring.js';
import ProductItem from './product-item.js';
import { transformSearchspringProduct } from '../utils/data.js';

export default {
    components: {
        ProductItem,
        Slick,
    },

    props: {
        defaultValue: {
            type: String,
            default: null
        },
        isSearchOpen: {
            type: Boolean
        },
        isSearchspringEnabled: {
            type: Boolean
        },
        filters: {
            type: Array
        }
    },

    data() {
        return {
            isSearchLoading: false,
            search: this.defaultValue,
            defaultResults: [],
            productResults: [],
            suggestedResults: [],
            facets: {},
            totalResults: null,
        }
    },

    watch: { // Debounce and watchers - https://vuejs.org/v2/guide/computed.html#Watchers
        search(value) {
            if (value) {
                this.isSearchLoading = true;
                this.debouncedPerformSearch();
                
            } else {
                this.resetValues();
            }
        },

        isSearchOpen(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.search.focus();
                });
            }
        }
    },

    created() {
        this.debouncedPerformSearch = debounce(this.performSearch, 500);
        
        if (this.defaultValue) {
            this.search = this.defaultValue;
            this.debouncedPerformSearch();
        }
    },

    methods: {
        toggleSearch() {
            app.toggleSearch();
        },

        resetValues() {
            this.defaultResults = [];
            this.productResults = [];
            this.suggestedResults = [];
            this.facets = {};
            this.totalResults = null;
        },

        async performSearch() {
            if (this.search) {
                if (this.isSearchspringEnabled) {
                    // Recommended flow by Searchspring:
                    // 1. Customer enters query
                    // 2. Suggest API
                    // 3. Autocomplete API with Suggest API result
                    const suggestions = await fetchSuggestResults({ q: this.search });
                    this.suggestedResults = suggestions.alternatives;
                    const query = suggestions.suggested?.text || this.search;
                    const data = {
                        q: query,
                        resultsPerPage: 8,
                        "bgfilter.ss_available": 1
                    };
                    const results = await fetchAutocompleteResults(data);
                    this.productResults = results.results?.map(product => transformSearchspringProduct(product)) || [];
                    this.facets = results.facets?.reduce((facets, facet) => {
                        if (!this.filters.includes(facet.field)) return facets;

                        facets[facet.field] = facet;
                        return facets;
                    }, {});
                    this.totalResults = results.pagination?.totalResults;

                } else {
                    // Predictive Search API - https://shopify.dev/docs/themes/ajax-api/reference/predictive-search
                    await axios.get(`/search/suggest.json?q=${this.search}&resources[type]=product&resources[limit]=8`).then(({ data }) => {
                        this.defaultResults = data.resources.results.products;
        
                    }).catch((error) => {
                        console.log(error);
                        error;
                    });
                }
              
            } else {
                this.resetValues();
            }

            this.isSearchLoading = false;
        }
    } 
}